import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { isNull } from '../../util/check';
import SimpleBar from 'simplebar';
import { SimpleBarOptions } from 'simplebar-core';

@Component({
  selector: 'fn-scrollbar',
  templateUrl: './fn-scrollbar.component.html',
  styleUrls: ['./fn-scrollbar.component.scss'],
  // tslint:disable-next-line: no-host-metadata-property
  host: { 'data-simplebar': 'init' },
  encapsulation: ViewEncapsulation.None,
})
export class FnScrollbarComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() options: SimpleBarOptions;
  @Input() position: string;
  @Output() scrollEvent = new EventEmitter();

  elRef: ElementRef;
  SimpleBar: any;

  constructor(elRef: ElementRef) {
    this.elRef = elRef;
  }

  ngOnInit() { }

  ngAfterViewInit(): void {
    this.SimpleBar = new SimpleBar(
      this.elRef.nativeElement,
      this.options || {}
    );
    this.scrollEvent.emit(this.SimpleBar);
  }

  ngOnDestroy() {
    // if (this.SimpleBar) {
    // 	this.SimpleBar.unMount();
    // }

    this.SimpleBar = null;
    this.scrollEvent.unsubscribe();
  }
  setScrollToButtom(isVertical?: boolean) {
    setTimeout(() => {
      const myElem = this.elRef.nativeElement.querySelector(
        "div.simplebar-content"
      );
      if (isNull(myElem)) {
        return;
      }
      let scrollMaxValue: number;
      let scrollPosition: string;
      let elemScrollValue: number;
      if (isVertical) {
        scrollMaxValue = this.elRef.nativeElement.scrollHeight;
        scrollPosition = "scrollTop";
        elemScrollValue = myElem.scrollHeight;
      } else {
        scrollMaxValue = this.elRef.nativeElement.scrollWidth;
        scrollPosition = "scrollLeft";
        elemScrollValue = myElem.scrollWidth;
      }
      if (elemScrollValue > scrollMaxValue) {
        this.SimpleBar.getScrollElement()[scrollPosition] = myElem.scrollHeight;
      }
    });
  }
  setScrollToTop(isVertical?: boolean) {
    setTimeout(() => {
      const myElem = this.elRef.nativeElement.querySelector(
        "div.simplebar-content"
      );
      if (isNull(myElem)) {
        return;
      }
      const scrollPosition = isVertical ? "scrollTop" : "scrollLeft";
      this.SimpleBar.getScrollElement()[scrollPosition] = 0;
    });
  }
}
